import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const createAdminFaq = (_, params) => {
  return Api(endPoints.createAdminFaq, params, requestType.POST);
};

const gatAdminFaqByUserType = (typeee) => {
  return Api(
    `${endPoints.gatAdminFaqByUserType}/${typeee}`,
    null,
    requestType.GET
  );
};

const deleteAdminFaq = (id) => {
  return Api(`${endPoints.deleteAdminFaq}/${id}`, null, requestType.DELETE);
};

const updateAdminFaq = (id, params) => {
  return Api(`${endPoints.updateAdminFaq}/${id}`, params, requestType.PUT);
};

export {
  createAdminFaq,
  gatAdminFaqByUserType,
  deleteAdminFaq,
  updateAdminFaq,
};
